import { render } from "./property-seolink.vue?vue&type=template&id=53ee1513"
import script from "./property-seolink.js?vue&type=script&lang=js"
export * from "./property-seolink.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__